import type { MessageKey } from '@/shared/lib/i18n';

/**
 * Map well-known acquire / REST error prefixes to translatable strings.
 * Anything unrecognized falls through to the raw error message — minimum
 * viable, no silent swallowing.
 *
 * Lives in `model/` rather than next to a single form so the home page
 * (Discord branch) and the LobbyJoinForm both import it from the feature
 * barrel rather than reaching into `ui/`.
 */
export const messageKeyForLobbyError = (err: string): MessageKey | null => {
  if (err.startsWith('discord_unavailable')) return 'platform.error.discord_unavailable';
  return null;
};
